import ApiClient from "./ApiClient"

const API_NAME = "WeConnect"
const BASE_PATH = "office"

const client = new ApiClient(API_NAME)

export default {
  get(businessId) {
    return client.get(`/business/${businessId}/${BASE_PATH}`)
  }
}
